import * as SocialContentWall from './SocialContentWall.jsx';
import * as Collage from './Collage.jsx';
import ContentVoting from './ContentVoting.jsx';
import SocialContentCarousel from './SocialCarousel/SocialCarousel.jsx';

export default {
  SocialContentWall:     SocialContentWall,
  Entries:               SocialContentWall,
  SocialContentCarousel: SocialContentCarousel,
  Collage:               Collage,
  Voting:                ContentVoting,
};
